import {
  Button,
  Col,
  Flex,
  Image,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Spin,
  Tabs,
  Typography,
  Upload,
  UploadProps,
} from "antd";
import { RedemptionGroupedData } from ".";
import Container from "../Container";
import { useEffect, useState } from "react";
import Table, { ColumnsType } from "antd/es/table";
import { formatDateTimeISO } from "../../../utils/date";
import { useNavigate } from "react-router-dom";
import { KycData } from "../inventory";
import { UploadOutlined } from "@ant-design/icons";
import handleUploadFile from "../../../utils/uploadFileS3";
import { v4 as uuidv4 } from "uuid";
import useTelechoice, { TELECHOICE_PREFIX } from "./useTelechoice";
import { useGetInventoryQuery, useUpdateTelechoiceInventoryMutation } from "../../../api/slowboatApi";
import useFetchUsername from "../../../hooks/useFetchUsername";
import dayjs from "dayjs";

const { Text } = Typography;
const UPLOAD_KYC_MEDIA_URL = "https://gr5l78aozj.execute-api.ap-southeast-1.amazonaws.com/prod/sb-redemption/redeem/kyc"
const MANUAL_QR_URL = "https://gr5l78aozj.execute-api.ap-southeast-1.amazonaws.com/prod/sb-redemption/admin/manual-qr"
const S3_BASE_URL = "https://redemption-kyc-upload.s3.ap-southeast-1.amazonaws.com/"

interface RedemptionRow {
  manualQr?: boolean;
  simIdx: number;
  assignedSimSn: string | null;
  status: string;
  redemptionDate: string | null;
}

console.log("environment", process.env.NODE_ENV, process.env.VERCEL_ENV);

interface InventoryModalProps {
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;

  data: RedemptionGroupedData | null;
}

export default function RedemptionDetailsModal(props: InventoryModalProps) {
  const navigate = useNavigate();
  const { data: inventoryData } = useGetInventoryQuery();
  const [activeTabKey, setActiveTabKey] = useState("1");

  // Manual QR handling
  const [kycData, setKycData] = useState<KycData | undefined>();
  const [messageApi, contextHolder] = message.useMessage();
  const [manualSimIdx, setManualSimIdx] = useState<number | null>(1);
  const [manualSimIccid, setManualSimIccid] = useState("");
  const [manualSimEmail, setManualSimEmail] = useState("");
  const [manualSimSmdp, setManualSimSmdp] = useState("");
  const [manualSimActCode, setManualSimActCode] = useState("");
  const [manualSimConfmCode, setManualSimConfmCode] = useState("");
  const [file, setFile] = useState<File>();
  const [manualQrUrl, setManualQrUrl] = useState<string>();

  // Telechoice confirmation code-based plugin
  const telcSim = useTelechoice(kycData?.productId);
  const [updTelechoice] = useUpdateTelechoiceInventoryMutation();
  const empName = useFetchUsername();

  useEffect(() => {
    setKycData(undefined);
    setManualSimIccid("");
    setManualSimEmail("");
    setManualSimSmdp("");
    setManualSimActCode("");
    setFile(undefined);
    setManualQrUrl("");
    setManualSimConfmCode("");
  }, [props.data?.orderId, manualSimIdx]);

  useEffect(() => {
    if (telcSim === undefined) {
      return;
    }
    setManualSimConfmCode(telcSim.confirmationCode);
  }, [telcSim]);

  function handleOk() {
    // TODO: Save
    props.setIsModalVisible(false);
  }

  function handleCancel() {
    props.setIsModalVisible(false);
  }

  function handleViewKycData(record: RedemptionRow) {
    // Coming soon
    console.log("rec", record);
    if (record.manualQr) {
      setActiveTabKey("2")
      return;
    }
    navigate(`/sb-inventory?simSn=${record.assignedSimSn}&action=kycData`);
  }

  function handleManualQrSubmission(record: RedemptionRow) {
    setActiveTabKey("2");
    setManualSimIdx(record.simIdx);
    retrieveManualKycData(record.simIdx);
  }

  const columns: ColumnsType<RedemptionRow> = [
    {
      title: "#",
      dataIndex: "simIdx",
      width: 5,
      key: "simIdx",
      sorter: (a, b) => a.simIdx - b.simIdx,
    },
    {
      title: "Assigned SIM SN",
      dataIndex: "assignedSimSn",
      key: "assignedSimSn",
      sorter: (a, b) => a.assignedSimSn?.localeCompare(b.assignedSimSn!!) ?? -1,
      render: (value: string, record: RedemptionRow) => value === null ? "-" : (value === "" ? "KYC Submitted - Manual Submission Required" : (value + (record.manualQr ? " (Manual)" : ""))),
    },
    {
      title: "Confirmation Code",
      dataIndex: "confirmationCode",
      key: "confirmationCode",
      render: (_, record: RedemptionRow) => {
        const matchOrderNumbers = inventoryData?.find(x => x.orderNumber === props.data?.orderId);
        console.log("matchOrderNumbers", matchOrderNumbers);
        return inventoryData?.find(x =>
            x.orderNumber === props.data?.orderId
            && x.simIdx === record.simIdx.toString())?.confirmationCode ?? "-"
      }
    },
    {
      title: "Redemption Date",
      dataIndex: "redemptionDate",
      key: "redemptionDate",
      sorter: (a, b) => a.redemptionDate?.localeCompare(b.redemptionDate!!) ?? -1,
      render: (value: string) => value === null ? "-" : formatDateTimeISO(value),
    },
    {
      title: "Action",
      key: "operation",
      width: 5,
      render: (text, record) => (
        <>
          {record.assignedSimSn !== "" &&
            <Button
              type="primary"
              disabled={record.assignedSimSn === null}
              onClick={() => handleViewKycData(record)}
            >
              Go to KYC Data
            </Button>
          }
          <Button
            type="primary"
            // disabled={record.assignedSimSn !== ""}
            onClick={() => handleManualQrSubmission(record)}
          >
            Manual Send QR
          </Button>
        </>
      ),
    },
  ];

  console.log("props.data", props.data);
  const simData: RedemptionRow[] = props.data?.kycs.map((kyc, idx): RedemptionRow => ({
    simIdx: kyc.simIdx,
    assignedSimSn: kyc.assignedSimSn ?? null,
    status: kyc.status,
    redemptionDate: kyc.assignedSimSn ? kyc.updatedAt : null,
    manualQr: kyc.manualQr ?? false
  })) ?? [];

  function retrieveManualKycData(simIdx?: number) {
    const idx = simIdx ? simIdx : manualSimIdx;
    const alertInfo = ("Retrieving KYC data for order " + props.data?.orderId
                      + " for SIM #" + idx);
    message.loading(alertInfo);
    console.log(alertInfo);
    const kyc = props.data?.kycs.find(k => k.simIdx === idx);
    setKycData(kyc as unknown as KycData);
    setManualSimEmail((kyc as unknown as KycData).email);
    message.destroy();
  }


  const uploadProps: UploadProps = {
    accept: ".jpg/.png/.jpeg",
    beforeUpload: (file) => {
      return false;
    },
    onChange: async (file) => {
      console.log("uploaded file", file);
      const f = file.file as unknown as File;
      try {
        const parts = f.name.split(".");
        setFile(f);

        // handle file upload to S3 and store only QR code here
        const id = uuidv4();
        const objId = await handleUploadFile(
          UPLOAD_KYC_MEDIA_URL + `?folder=${props.data?.orderId}/qrcode/${id}`,
          f
        );
        console.log("obj id", objId);
        const url = S3_BASE_URL + objId;
        setManualQrUrl(url);
      } catch (ex) {
        messageApi.error("Error uploading QR code, please try again");
      }
    },
    showUploadList: false
  }

  async function handleSendQr() {
    if (props.data === null || manualSimIdx == null) {
      return;
    }
    const pb = {
      orderNo: props.data.orderId,
      simIdx: manualSimIdx,
      qrUrl: manualQrUrl,
      email: manualSimEmail,
      iccid: manualSimIccid,
      smdp: manualSimSmdp,
      activationCode: manualSimActCode
    }
    messageApi.loading("Submitting QR email...");
    const res = await fetch(MANUAL_QR_URL, {
      method: "post",
      body: JSON.stringify(pb)
    });

    messageApi.destroy();
    if (res.status !== 200) {
      messageApi.error("Error sending manual QR email. Please report this error");
      return;
    }

    // once email sent then update telechoice if needed
    if (kycData?.platformId.startsWith(TELECHOICE_PREFIX)) {
      messageApi.loading("Updating Telechoice inventory");
      updTelechoice({
        orderId: props.data.orderId,
        simIdx: manualSimIdx.toString(),
        confirmationCode: manualSimConfmCode,
        custEmail: manualSimEmail,
        empName: empName
      })
      .unwrap()
      .then(() => {
        messageApi.destroy();
        messageApi.success("Updated inventory")
      })
      .catch(() => {
        messageApi.destroy();
        messageApi.error("Error updating Telechoice inventory");
      });
    }

    messageApi.success("Successfully sent email!");
    setActiveTabKey("1");
    props.setIsModalVisible(false);
  }

  async function handleDownloadFile(url: string) {
    try {
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      const durl = window.URL.createObjectURL(new Blob([buf]));
      const ln = document.createElement("a");
      const parts = url.split(".");
      const ext = parts[parts.length - 1];
      const fn = props.data!!.orderId + " Passport Photo." + ext;
      ln.href = durl;
      ln.setAttribute("download", fn);
      document.body.appendChild(ln);
      ln.click();
    } catch (ex) {
      messageApi.error("Error creating download link");
      console.error("Error creating download link");
      console.error(ex);
    }
  }
  console.log("details", props.data)

  return (<>
    {contextHolder}
    <Modal
      className="order-modal"
      width="80%"
      title="Redemption Details"
      visible={props.isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
        <Tabs
          type="card"
          activeKey={activeTabKey}
          defaultActiveKey="1"
          onChange={k => setActiveTabKey(k)}
          items={[
            {
              label: "Redemption Information",
              key: "1",
              children: (
                <Container>
                  <Text type="secondary">Order Information</Text>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Order Date"
                        value={props.data ? formatDateTimeISO(props.data.orderDate) : "-"}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Order ID"
                        value={props.data?.orderId}
                      />
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Status"
                        value={props.data?.status + " redeemed"}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Order Email"
                        value={props.data?.orderEmail ?? "Unavailable"}
                      />
                    </Col>
                  </Row>
                  <Text type="secondary">SIMs</Text>
                  <Table
                    columns={columns}
                    dataSource={simData}
                    pagination={{
                      defaultPageSize: 5,
                      pageSizeOptions: [5, 10, 15, 20],
                      defaultCurrent: 1
                    }}
                    size="small"
                    bordered
                    showHeader
                  />
                </Container>
              ),
            },
            {
              label: "Manual QR Submission",
              key: "2",
              forceRender: true,
              children: <>
                <Flex gap={8} vertical>
                  <Input
                    readOnly
                    addonBefore="Order ID"
                    value={props.data?.orderId}
                  />

                  <InputNumber
                    addonBefore="SIM Index No"
                    defaultValue={1}
                    min={1}
                    max={props.data?.kycs.length ?? 1}
                    value={manualSimIdx}
                    onChange={(e) => {
                      setManualSimIdx(e);
                      retrieveManualKycData(e ?? undefined);
                    }}
                  />
                  <Text type="secondary">KYC Data</Text>
                  <Button type="primary" onClick={() => retrieveManualKycData()}>Retrieve</Button>
                  <Input
                    addonBefore="Customer Email to send QR"
                    value={manualSimEmail}
                    onChange={e => setManualSimEmail(e.target.value)}
                  />
                  <Row gutter={8}>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Passport Number"
                        value={kycData?.passportNumber}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Passport Country"
                        value={kycData?.passportCountry}
                      />
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={8}>
                      <Input
                        readOnly
                        addonBefore="Given Name"
                        value={kycData?.givenName}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        readOnly
                        addonBefore="Middle Name (if any)"
                        value={kycData?.middleName}
                      />
                    </Col>
                    <Col span={8}>
                      <Input
                        readOnly
                        addonBefore="Surname"
                        value={kycData?.surname}
                      />
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Date of Birth"
                        value={kycData?.dob ? dayjs(kycData.dob).format("DD-MMM-YYYY") : ""}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        readOnly
                        addonBefore="Arrival Date"
                        value={kycData?.arrivalDate ? dayjs(kycData.arrivalDate).format("DD-MMM-YYYY") : ""}
                      />
                    </Col>
                  </Row>
                  <Flex gap={8}>
                    <Input
                      readOnly
                      addonBefore="Passport Photo"
                      value={kycData?.passportPhoto}
                    />
                    <Button
                      type="primary"
                      onClick={() => kycData?.passportPhoto && (
                        handleDownloadFile(kycData.passportPhoto))}
                      disabled={!kycData?.passportPhoto}
                    >
                      Download
                    </Button>
                    <Button
                      onClick={() => window.open(kycData?.passportPhoto)}
                      disabled={!kycData?.passportPhoto}
                    >
                      Open
                    </Button>
                  </Flex>
                  <Text type="secondary">SIM to Issue</Text>
                  <Input
                    readOnly
                    addonBefore="SKU"
                    value={kycData?.platformId}
                  />
                  <Input
                    addonBefore="SIM ICCID"
                    value={manualSimIccid}
                    onChange={e => setManualSimIccid(e.target.value)}
                  />
                  <Flex gap={8}>
                    <Input
                      addonBefore="SMDP+ Address"
                      value={manualSimSmdp}
                      onChange={e => setManualSimSmdp(e.target.value)}
                    />
                    <Input
                      addonBefore="Activation Code"
                      value={manualSimActCode}
                      onChange={e => setManualSimActCode(e.target.value)}
                    />
                  </Flex>
                  <Input
                    addonBefore="Confirmation Code"
                    value={manualSimConfmCode}
                    onChange={e => setManualSimConfmCode(e.target.value)}
                  />
                  <Flex justify="space-between" align="center">
                    <Text>QR Code Image</Text>
                    <Flex gap={8} align="center">
                      <Typography.Text>
                        {file?.name ?? "No file selected"}
                      </Typography.Text>
                      <Upload {...uploadProps}>
                        <Button icon={<UploadOutlined />}>Upload</Button>
                      </Upload>
                    </Flex>
                  </Flex>
                  { manualQrUrl &&
                    <Flex justify="center">
                      <Image src={manualQrUrl} width={200} />
                    </Flex>
                  }
                  <Button
                    type="primary"
                    disabled={manualSimIdx === null || manualSimIccid == null || manualSimEmail == null
                              || manualSimEmail.length === 0
                              || manualSimIccid.length === 0
                              || manualQrUrl === undefined
                              || manualQrUrl.length === 0}
                    onClick={handleSendQr}
                  >
                    Send QR to customer
                  </Button>
                </Flex>
              </>
            }
          ]}
        />
    </Modal>
  </>);
}
